import { twJoin } from "tailwind-merge";

import infoCircleIcon from "@/assets/icons/info-circle.svg";

import { Tooltip } from "./Tooltip";

interface InfoProps {
  label?: string;
  tooltip: NonNullable<React.ReactNode>;
  variant?: "primary" | "secondary";
  width?: "default" | "compact";
}

export function Info({ label, tooltip, variant = "primary", width }: InfoProps): React.ReactNode {
  const icon = (
    <span
      className={twJoin(
        "shrink-0",
        variant === "primary" && "text-text-brand",
        variant === "secondary" && "text-text-secondary",
      )}
    >
      <svg width={16} height={16} fill="none" aria-hidden="true">
        <use xlinkHref={`#${infoCircleIcon}`} />
      </svg>
    </span>
  );

  if (tooltip === "") {
    return icon;
  }

  return (
    <Tooltip tooltip={tooltip} offset="spacious" width={width}>
      <button
        type="button"
        aria-label={label ?? "More information"}
        className="shrink-0 rounded-full focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-border-brand"
        // making sure clicking the icon doesn't mean it will never open the tooltip again
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        {icon}
      </button>
    </Tooltip>
  );
}
